var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isEmpty && 'stream--empty stream-workarea-components--empty']},_vm._l((_vm.nestedComponents),function(component,index){return _c('WorkareaComponent',{key:`${component.id}-${component.parentId}-${component.order}-${index}`,attrs:{"component":component}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }